<div class="full-page-container">
  <div class="d-none d-lg-block">
    <fgb-banner [title]="'partner.page.title' | translate"></fgb-banner>
  </div>

  <fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/'"></fgb-page-header>

  <fgb-account-nav></fgb-account-nav>
  <div *ngIf="partnerLimit$ | async as partnerLimit" class="container">
    <div class="add-partner-container">
      <div class="m-0">
        <h5 class="title-partner">{{ 'partner.title' | translate }}</h5>
        <ng-container *ifScreenSize="screenType.Desktop">
          <p
            class="m-0 font-size-14 partner-description"
            [innerHTML]="'partner.page.info.text' | translate | markdownTranslate"
          ></p>
        </ng-container>
        <ng-container *ifScreenSize="screenType.Mobile">
          <p
            class="m-0 font-size-14 partner-description"
            [innerHTML]="'partner.page.info.text.mobile' | translate | markdownTranslate"
          ></p>
        </ng-container>
        <div class="d-flex align-items-center action-container">
          <button
            class="partner-button border-0 text-center text-white bg-primary pt-0 d-flex align-items-center justify-content-center"
            (click)="openAddForm()"
            aria-label="Add new partner"
            [ngClass]="{
              active: !showAcceptForm,
              'not-active': showAcceptForm,
              'greyed-out': currentPartnerCount >= partnerLimit
            }"
          >
            <span class="material-icons me-2"> person_add_alt_1 </span>
            <label class="cursor-pointer mb-0">{{ 'partner.add.form.title' | translate }}</label>
          </button>
          <button
            class="partner-button border-0 text-center text-white bg-success pt-0 d-flex align-items-center justify-content-center"
            (click)="openAcceptForm()"
            [ngClass]="{ active: !showAddForm, 'not-active': showAddForm, 'greyed-out': currentPartnerCount >= partnerLimit }"
            aria-label="Accept partner"
          >
            <span class="material-icons me-2"> add_task </span>
            <label class="cursor-pointer mb-0">{{ 'partner.accept' | translate }}</label>
          </button>
        </div>
      </div>
      <ng-container *ngIf="showAddForm || showAcceptForm">
        <hr class="m-2" />
        <div class="card-body">
          <fgb-partner-add-form (close)="openAddForm()" *ngIf="showAddForm"></fgb-partner-add-form>
          <fgb-partner-accept-form (close)="openAcceptForm()" *ngIf="showAcceptForm"></fgb-partner-accept-form>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="currentPartnerCount > 0; else partnerPlaceholder">
      <fgb-partner-list></fgb-partner-list>
    </ng-container>
    <ng-template #partnerPlaceholder>
      <h5 class="title-partner">{{ 'no.partner.title' | translate }}</h5>
      <div class="card no-partner-card rounded">
        <div class="column-header">
          <div class="col-10 d-lg-none d-block">
            <label class="fw-bold">{{ 'partner.details' | translate }}</label>
          </div>
          <div class="column-name d-none d-lg-block col-name">
            <label>{{ 'partner.fullname' | translate }}</label>
          </div>
          <div class="column-name d-none d-lg-block col-email">
            <label>{{ 'partner.email' | translate }}</label>
          </div>
          <div class="column-name d-none d-lg-block col-status">
            <label>{{ 'partner.status' | translate }}</label>
          </div>
          <div class="column-name col-action">
            <label>{{ 'partner.action' | translate }}</label>
          </div>
        </div>
        <div class="no-partner-body">
          <ng-container *ifScreenSize="screenType.Desktop">
            <p class="mt-3 font-size-14">
              {{ 'no.partner.placeholder.description' | translate }}
            </p>
          </ng-container>
          <ng-container *ifScreenSize="screenType.Mobile">
            <p class="mt-3 font-size-14 text-center">
              {{ 'no.partner.placeholder.description.mobile' | translate }}
            </p>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </div>
</div>
